import { render } from "./FancyGridStub.vue?vue&type=template&id=04c777a8"
import script from "./FancyGridStub.vue?vue&type=script&lang=js"
export * from "./FancyGridStub.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__